// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";

export function getShipmentStatusesDataView(state: ApplicationState) {
    return getDataView(state.greif.data.shipmentStatuses, {});
}
